var $d943521233798059$exports = {};
$d943521233798059$exports = {
  "backButton": args => "Retornar a ".concat(args.prevMenuButton),
  "moreActions": "Mais a\xE7\xF5es",
  "unavailable": "Indispon\xEDvel. Expanda para ver os detalhes"
};
export { $d943521233798059$exports as default };